import { render, staticRenderFns } from "./SliderMiniaturas.vue?vue&type=template&id=4515f713&scoped=true&"
import script from "./SliderMiniaturas.vue?vue&type=script&lang=js&"
export * from "./SliderMiniaturas.vue?vue&type=script&lang=js&"
import style0 from "./SliderMiniaturas.vue?vue&type=style&index=0&id=4515f713&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4515f713",
  null
  
)

export default component.exports